<template lang="pug">
  div.body.body-table.garbage-table.transport-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="letSearch")
              input(type="search" placeholder="" v-model="searchModel")
            div.parameters
            div.actions-panel
              e-button-add(@click.prevent.stop="addNewRowToTable")
              // button(type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div
        e-table-editable(
          ref="rubbishCollectors"
          :attributes="rubbishCollectorsAttr"
          :dataUrl="rubbishCollectorsDataUrl"
          :postUrl="rubbishCollectorsPostUrl"
          :patchUrl="rubbishCollectorsPatchUrl"
          :deleteUrl="rubbishCollectorsDeleteUrl"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
          :actionColumnWidth="200"
          :enablePagination="true"
          @paginate="onPaginate"
          @sortByField="onSortByField"
          :prepareRow="prepareRow"
        )
          template(slot="buttons" slot-scope="props")
            button(
              v-if="props.acceptEdit"
              @click.prevent="toggleEditable(props.model)"
              class="row-edit"
              title="Редактировать"
            )
            button(
              v-if="props.acceptDelete"
              @click.prevent="deleteRow(props.model)"
              class="row-delete"
              title="Удалить"
            )
            button(
              :style="{display: 'none'}"
              v-if="props.acceptCreate"
              @click.prevent="openToTable(props.model)"
              class="row-config"
              title="Информация о Техническом обслуживании и Ремонте"
            )
            button(
              v-if="props.acceptCreate"
              @click.prevent="copyRow(props.model)"
              class="row-copy"
              title="Продублировать"
            )

      e-modal(
        v-if="transportMaintenanceTableOpened"
        @close="closeTable()"
        @confirm="closeTable()"
        title="Информация о Техническом обслуживании и Ремонте"
      )
        slot
          transport-maintenance-table(
            :id="id"
            :inputModel="inputModel"
            ref="transportMaintenanceTable"
          )
        div(slot="footer")
          button(
            type="button"
            @click="closeTable()"
          ).actions-filter-panel__button.standart Закрыть


</template>

<script>
  import {transport, core} from '../../../api/api-endpoints.js'
  import {tkoOffline} from '../../../api/api-offline-endpoints.js'
  import year from  '../../../utils/year.js'
  import TransportMaintenanceTable from "./transport-maintenance-table";

  const Model = () => ({
    tko_transport_brand_id: '',
    tko_transport_load_type_id: '',
    tko_transport_load_method_id: '',
    brand: '',
    model: '',
    load_type: '',
    load_method: '',
    characteristic: '',
    number: '',
    year: '',
  })

  export default {
    name: 'r-transport-table',
    components: {TransportMaintenanceTable},
    props: {
      id: null,
      fields: Object
    },
    data () {
      return {
        inputModel: Object.create(null),
        transportMaintenanceTableOpened: false,
        operationType: null,
        search: '',
        searchModel: '',
        paginationQuery: null,
        sort: null
      }
    },
    computed: {
      collections() {
        return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}
      },
      tableInOnlineMode () {
        return this.id
      },
      selectListOptions () {
        return [
          {
            id: 'rubbishCollectors',
            name: 'Автопарк'
          }
        ]
      },
      rubbishCollectorsAttr () {
        return {
          tko_transport_brand_id: {
            label: 'Марка',
            validationRulePattern: '(\\.*)',
            placeholder: 'Выберите марку',
            // required: true,
            select: {
              options: this.brands,
            },
            transform: (model) => {
              return this.getOptionName(this.brands, model.tko_transport_brand_id)
            },
            sort: true
          },
          model: {
            label: 'Модель',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите модель',
            // required: true,
          },
          tko_transport_load_type_id: {
            sort: true,
            label: 'Тип загрузки',
            validationRulePattern: '(\\.*)',
            placeholder: '',
            // required: true,
            // disabled: true,
            select: {
              options: this.loadTypes
            },
            transform: (model) => {
              return this.getOptionName(this.loadTypes, model.tko_transport_load_type_id)
            },
          },
          tko_transport_load_method_id: {
            sort: true,
            label: 'Способ загрузки',
            validationRulePattern: '(\\.*)',
            placeholder: 'Выберите способ загрузки',
            // required: true,
            // disabled: true,
            select: {
              options: this.loadMethods
            },
            transform: (model) => {
              return this.getOptionName(this.loadMethods, model.tko_transport_load_method_id)
            },
          },
          characteristic: {
            label: 'Характеристика ТС',
            validationRulePattern: '(\\.*)',
            placeholder: '',
            // disabled: true,
            // required: true
          },
          number: {
            label: 'Государственный номер',
            validationRulePattern: '(\\.*)',
            // required: true,
            placeholder: 'Введите гос. номер'
          },
          year: {
            sort: true,
            label: 'Год выпуска',
            validationRulePattern: '(\\.*)',
            placeholder: 'Выберите год выпуска ТС',
            select: {
              options: year.getSpecifiedYearsOptions(1960),
              optionValueKey: 'name'
            },
            transform: model => year.getSpecifiedYearsOptions(1960).find(v => v.name === model.year).name
          }
        }
      },
      rubbishCollectorsDataUrl () {
        if (this.id) {
          let routeQuery = {
            query: {
              tko_operator_id: this.id
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }
          if (this.sort) {
            routeQuery.query.sort = this.sort
          }
          if (this.paginationQuery) {
            routeQuery.query = Object.assign(routeQuery.query, this.paginationQuery)
          }

          return transport.park(routeQuery)
        }
        return tkoOffline.operatorTransportTable(this.$route.name)
      },
      brands () {
        return this.collections.tko_transport_brand || []
      },
      models () {
        let obj = {}
        this.transportList.forEach(v => {
          if (v.model && v.brand) {
            obj[v.model] = {
              brand_id: v.brand.id,
              id: v.model,
              name: v.model
            }
          }
        })
        console.log(obj)
        return Object.values(obj)
      },
      loadTypes () {
        return this.collections.tko_transport_load_type || []
      },
      loadMethods () {
        return this.collections.tko_transport_load_method || []
      },
      transportList () {
        let list = this.$store.getters.readUrlEndpoint(
          this.getTransportListEndpoint()
        )
        if (list && list.data) {
          return list.data
        }
        return []
      }
    },
    created(){
      this.loadCollections()
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      getOptionName(collection, id) {
        if (!collection || collection.length < 1 || !id) {
          return null
        }
        return collection.find(v => v.id === id).name
      },
      async loadCollections() {
        return await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getCollectionEndpoint()
        })
      },
      // tmp method
      prepareRow (model) {
        model.operatorName = this.fields.name || ''
        return model
      },
      // tmp method
      closeTable () {
        // tmp method
        // grab data from table for save in mongo
        let data = this.$refs.transportMaintenanceTable.getTableData()
        if (data && data.data && data.data.length > 0) {
          let lastInfo = JSON.parse(JSON.stringify(data.data[data.data.length - 1]))
          console.log('closeTable', this.inputModel)
          this.$refs.rubbishCollectors.findByIdAndSetDataAndSave(
            this.inputModel.id || this.inputModel._storeUUID,
            {
              last_to_date: lastInfo.dt_start,
              last_to_velocity: lastInfo.velocity,
              registryOperatorTransportMaintenance: data.data
            }
          )
        } else {
          this.$refs.rubbishCollectors.findByIdAndSetDataAndSave(
            this.inputModel.id || this.inputModel._storeUUID,
            {
              last_to_date: '',
              last_to_velocity: '',
              registryOperatorTransportMaintenance: []
            }
          )
        }
        this.transportMaintenanceTableOpened = false
        this.inputModel = Object.create(null)
      },
      openToTable (model) {
        this.inputModel = Object.assign({}, model)
        this.transportMaintenanceTableOpened = true
      },
      clearModel (model) {
        let compareAttrModel = new Model()
        for (let key in compareAttrModel) {
          if (key === 'tko_transport_brand_id') {
            continue
          }
          model[key] = ''
        }
      },
      selectModel (model) {
        let autoCompleteData = {
          load_type: '',
          load_method: '',
          desc: ''
        }
        for (let i = 0; i < this.transportList.length; i++) {
          let v = this.transportList[i]
          if (v.brand && v.brand.id === model.brand && v.model && model.model && v.model === model.model) {
            if (v.load_type) {
              autoCompleteData.load_type = v.load_type.id
              autoCompleteData.labelForload_type = v.load_type.name
            }
            if (v.load_method) {
              autoCompleteData.load_method = v.load_method.id
              autoCompleteData.labelForload_method = v.load_method.name
            }
            autoCompleteData.desc = `Полная масса. кг: ${v.full_mass ? v.full_mass : ''}; Полезный объем кузова. куб. м.: ${v.body_capacity ? v.body_capacity: '' }; Грузоподъемность. кг: ${v.capacity}; Коэффициент уплотнения: ${v.compression_coef ? v.compression_coef: ''}`
            // put info about car, for use in schedule car list
            model.carInfo = v
            break
          }
        }
        for (let key in autoCompleteData) {
          model[key] = autoCompleteData[key]
        }
      },
      onPaginate (paginationQuery) {
        this.paginationQuery = paginationQuery
      },
      onSortByField ({sort}) {
        this.sort = sort
      },
      toggleEditable (model) {
        this.$refs.rubbishCollectors.toggleEditable(model)
      },
      deleteRow (model) {
        this.$refs.rubbishCollectors.deleteRow(model)
      },
      isOfflineSavedInStore (model) {
        return model._storeUUID && model._considerSaved
      },
      copyRow (model) {
        if (!model.id && !this.isOfflineSavedInStore(model)) {
          return
        }
        let deepCopy = JSON.parse(JSON.stringify(model))
        for (let key in deepCopy) {
          if (key.startsWith('_')) {
            delete deepCopy[key]
          }
        }
        delete deepCopy.id
        deepCopy.number = ''
        deepCopy.year = ''
        this.$refs.rubbishCollectors.createRow(deepCopy)
      },
      getTransportListEndpoint (route) {
        return transport.park(route)
      },
      getCollectionEndpoint() {
        return core.collection('tko_transport_brand,tko_transport_load_type,tko_transport_load_method')
      },
      async fetchData () {
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getTransportListEndpoint(this.$route),
          fromCache: true,
          params: {
            disableGlobalError: true
          }
        }).catch(e => {
          this.$e.errorBox(e)
        })
      },
      letSearch () {
        this.search = JSON.parse(JSON.stringify(this.searchModel))
      },
      afterValidate (ctx, model, errors, els) {
        let {tr} = els
        // added search data
        model.searchBody = ''
        for (let key in model) {
          if (typeof model[key] !== 'object' && !Array.isArray(model[key])) {
            model.searchBody += ` ${model[key]} `
          }
        }
        return errors
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {

        }
        // console.log(data.data)
        return data
      },
      rubbishCollectorsPostUrl (context, model) {
        return transport.car()
      },
      rubbishCollectorsPatchUrl (context, model) {
        return transport.car(model.id)
      },
      rubbishCollectorsDeleteUrl (context, model) {
        return transport.car(model.id)
      },
      addNewRowToTable () {
        let model = new Model()
        model.tko_operator_id = this.id || ''
        model.operatorName = this.fields.name || ''

        this.$refs.rubbishCollectors.createRow(model)
      }
    }
  }
</script>
